import * as activityType from '../enums/activity-types'
import * as contentType from '../enums/content-type'
import * as misc from '../enums/misc'
import * as socialMedia from '../enums/social-media'
import {MARKETING} from '../enums/localization-image-types'

const CONTENT_TYPES = {}

let registerType = (key, path) => {
  CONTENT_TYPES[key] = {path}
}
registerType(contentType.LESSON, '/static/custom-icons/cp-full-lesson.svg')
registerType(contentType.ACTIVITY, '/static/custom-icons/cp-activity.svg')
registerType(contentType.ASSESSMENT, '/static/custom-icons/cp-group.svg')
registerType(contentType.TEMPLATE, '/static/custom-icons/cp-template.svg')
registerType(contentType.TEACHING_TOOL, '/static/custom-icons/cp-teaching-tool.svg')
registerType(contentType.CLASSROOM_TOOLS, '/static/custom-icons/cp-teaching-tool.svg')
registerType(activityType.MONSTER_QUIZ_TYPE, '/static/custom-icons/monster-quiz.svg')
registerType(activityType.SHOUT_IT_OUT_TYPE, '/static/custom-icons/shout-it-out.svg')
registerType(activityType.RESPONSE_2_TYPE, '/static/custom-icons/response-2.svg')
registerType(activityType.SUPER_SORT_TYPE, '/static/custom-icons/super-sort.svg')
registerType(activityType.LABEL_REVEAL_TYPE, '/static/custom-icons/label-reveal.svg')
registerType(activityType.MATCH_EM_UP_TYPE, '/static/custom-icons/matchem-up.svg')
registerType(activityType.SPEED_UP_TYPE, '/static/custom-icons/speed-up.svg')
registerType(activityType.FILL_IN_THE_BLANKS_TYPE, '/static/custom-icons/fill-in-the-blanks.svg')
registerType(activityType.FLIP_OUT_TYPE, '/static/custom-icons/flip-out.svg')
registerType(activityType.GAME_SHOW_TYPE, '/static/custom-icons/game-show.svg')
registerType(activityType.RANK_ORDER_TYPE, '/static/custom-icons/rank-order.svg')
registerType(activityType.MEMORY_WATCH_TYPE, '/static/custom-icons/memory-watch.svg')
registerType(misc.CLOSE_ICON, '/static/custom-icons/close-white.svg')
registerType(misc.CLOSE_SLATE, '/static/custom-icons/close-slate.svg')
registerType(misc.CLOSE_SLATE_14PX, '/static/custom-icons/close-slate-14px.svg')
registerType(misc.CLOSE_BLUE, '/static/custom-icons/close-blue.svg')
registerType(MARKETING, '/static/marketing-content/SMEX_2_MARKETING.png')
registerType(misc.ELLIPSIS, '/static/custom-icons/cp-ellipsis.svg')
registerType(misc.ERROR_ICON, '/static/custom-icons/search-error-image.svg')
registerType(misc.PAGING_ENABLED, '/static/custom-icons/paging-enabled.svg')
registerType(misc.PAGING_DISABLED_LEFT, '/static/custom-icons/paging-disabled-left.svg')
registerType(misc.PAGING_DISABLED_RIGHT, '/static/custom-icons/paging-disabled-right.svg')
registerType(misc.PAGING_HOVER, '/static/custom-icons/paging-hover.svg')
registerType(misc.SEARCH_ICON, '/static/custom-icons/search-slate.svg')
registerType(misc.SEARCH_ICON_WHITE, '/static/custom-icons/search-white.svg')
registerType(misc.SEARCH_ICON_HOVER, '/static/custom-icons/search-blue.svg')
registerType(misc.SLSO_LOGO, '/static/custom-icons/logo.svg')
registerType(misc.SMEX_LOGO, '/static/custom-icons/SMEX_ICON.png')
registerType(misc.LOCK_ICON, '/static/custom-icons/baseline-lock-24-px.svg')
registerType(misc.STD_CHECKED, '/static/custom-icons/std-checked.svg')
registerType(misc.STD_UNCHECKED, '/static/custom-icons/std-unchecked.svg')
registerType(misc.LRG_CHECKED, '/static/custom-icons/lrg-checked.svg')
registerType(misc.LRG_UNCHECKED, '/static/custom-icons/lrg-unchecked.svg')
registerType(misc.FILTER_SLATE, '/static/custom-icons/filter-slate.svg')
registerType(misc.FILTER_WHITE, '/static/custom-icons/filter-white.svg')
registerType(misc.ERROR_INFO_ICON, '/static/custom-icons/warning.svg')
registerType(misc.ERROR_ICON_PREVIEWER, '/static/custom-icons/warning.svg')
registerType(misc.IMAGE_NOT_FOUND, '/static/placeholders/group-8.svg')
registerType(misc.IMAGE_NOT_FOUND_THUMBNAIL, '/static/placeholders/image-not-found.png')
registerType(misc.BLANK_IMAGE, '/static/placeholders/blank.png')
registerType(misc.SHARE_ICON_WHITE, '/static/custom-icons/share-white.svg')
registerType(misc.SHARE_ICON_WHITE_LARGE, '/static/custom-icons/share-white-large.svg')
registerType(misc.SHARE_ICON_BLUE, '/static/custom-icons/share-blue.svg')
registerType(misc.NOTEBOOK_ICON, '/static/custom-icons/notebook-icon.svg')
registerType(misc.WARNING_ICON_WHITE_LARGE, '/static/custom-icons/warning-white-large.svg')
registerType(misc.WARNING_ICON_GREY, '/static/custom-icons/warning-grey.svg')
registerType(misc.DOCUMENT_APPROVE, '/static/custom-icons/document-approve.svg')
registerType(misc.FILE_EXCHANGE, '/static/custom-icons/file-exchange.svg')
registerType(misc.WARNING_ICON_ORANGE, '/static/custom-icons/warning-orange.svg')
registerType(misc.DROPDOWN_CLOSED, '/static/custom-icons/dropdown-closed.svg')
registerType(misc.PLUS_BLUE, '/static/custom-icons/plus-blue.svg')
registerType(misc.PLUS, '/static/custom-icons/plus.svg')
registerType(misc.LRG_ERRORS_UNCHECKED, '/static/custom-icons/errors-checkbox.svg')
registerType(misc.NO_SHARED_RESOURCES, '/static/custom-icons/no-shared-resources.svg')
registerType(misc.NO_PENDING_RESOURCES, '/static/custom-icons/no-pending-resources.svg')
registerType(misc.NO_DECLINED_RESOURCES, '/static/custom-icons/no-declined-resources.svg')
registerType(misc.DROPDOWN_OPEN, '/static/custom-icons/dropdown-open.svg')
registerType(misc.SUCCESS_TOAST, '/static/custom-icons/moderation-illustration.svg')
registerType(misc.DECLINED_RESOURCES_CARD, '/static/custom-icons/illustrations-declined-resource.svg')
registerType(misc.DECLINED_MENU_INDICATOR, '/static/custom-icons/icon-new-item-menu-red.svg')
registerType(misc.APPROVED_MENU_INDICATOR, '/static/custom-icons/icon-new-item-menu-green.svg')
registerType(misc.PENDING_MENU_INDICATOR, '/static/custom-icons/icon-new-item-menu-orange.svg')
registerType(misc.WARNING_RED_ICON, '/static/custom-icons/warning-red.svg')
registerType(misc.GENERIC_AVATAR, '/static/custom-icons/generic-avatar.svg')
registerType(misc.EDIT_PEN_HOVER, '/static/custom-icons/edit-hover.svg')
registerType(misc.EDIT_PEN, '/static/custom-icons/edit-slate.svg')
registerType(misc.SMEX_MOBILE_LOGO, '/static/custom-icons/smex-mobile-logo.png')
registerType(misc.NEW_ICON, '/static/custom-icons/new-tag-lg.svg')
registerType(misc.NEW_ICON_LEFT, '/static/custom-icons/new-tag-left.svg')
registerType(misc.NEW_LOOK, '/static/custom-icons/new-look.svg')
registerType(misc.NEW_RESOURCES, '/static/custom-icons/new-resources.svg')
registerType(misc.SAVE_ONLINE, '/static/custom-icons/save-online.svg')
registerType(misc.LEARN_MORE, '/static/custom-icons/save-online.svg')
registerType(misc.CANCEL_BLACK, '/static/custom-icons/cancel-black.svg')
registerType(misc.CANCEL_HOVER, '/static/custom-icons/cancel-hover.svg')
registerType(misc.LEGACY_SIGN_IN, '/static/custom-icons/64-user-add-female-asian-2@2x.png')
registerType(misc.ID_SMART_LOGO, '/static/custom-icons/shape-copy-2.svg')
registerType(misc.ID_FOOTER, '/static/custom-icons/about-smart-privacy-copy-2.svg')
registerType(misc.SEARCH_ICON_SIGN_IN_MODAL, '/static/custom-icons/29-cloud-computer-image-picture-sync.svg')
registerType(misc.CLOUD_ICON_SIGN_IN_MODAL, '/static/custom-icons/31-cloud-computer-audio-media-upload.svg')
registerType(misc.INFO, '/static/custom-icons/info.svg')
registerType(misc.INFO_HOVER, '/static/custom-icons/info-hover.svg')
registerType(socialMedia.FACEBOOK, '/static/custom-icons/social-media/facebook.png')
registerType(socialMedia.PINTEREST, '/static/custom-icons/social-media/pinterest.png')
registerType(socialMedia.TWITTER, '/static/custom-icons/social-media/twitter.png')
registerType(socialMedia.EMAIL, '/static/custom-icons/social-media/email.png')
registerType(socialMedia.FACEBOOK_HOVER, '/static/custom-icons/social-media/facebook-hover.png')
registerType(socialMedia.PINTEREST_HOVER, '/static/custom-icons/social-media/pinterest-hover.png')
registerType(socialMedia.TWITTER_HOVER, '/static/custom-icons/social-media/twitter-hover.png')
registerType(socialMedia.EMAIL_HOVER, '/static/custom-icons/social-media/email-hover.png')
registerType(misc.COMBINED_SHAPE, '/static/custom-icons/combined-shape.svg')
registerType(misc.ICON_INFO, '/static/custom-icons/icon-info.svg')
registerType(misc.RIGHT_ENABLED, '/static/custom-icons/right-enabled.svg')
registerType(misc.STUDENT_DEVICES, '/static/custom-icons/student-devices.svg')
registerType(misc.DEVICE_ICON, '/static/custom-icons/student-devices.svg')

export default {
  resolve(type) {
    let icon = CONTENT_TYPES[type]
    if (!icon || !icon.path) {
      throw new Error('Could not determine icon path for ' + type)
    }
    return icon.path
  }
}
